"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HintTooltip = exports.UmbHintTooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const Tooltip_1 = require("Views/Shared/Components/Tooltip");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
class UmbHintTooltip extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.umbraco-forms-field .form-info-icon';
    }
    OnInit() {
        this.el.forEach(el => {
            this.InitToolTip(el);
        });
    }
    InitToolTip(el) {
        const toolTipText = el.getAttribute('title');
        el.removeAttribute('title');
        const iconInfo = this.getInfoIcon();
        if (toolTipText) {
            (0, Tooltip_1.renderTooltip)(el, {
                content: toolTipText,
            }, iconInfo);
        }
    }
    getInfoIcon() {
        return ((0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "info-outline", className: "fill-df-gray-text body-md", viewBox: "0 0 24 24" }));
    }
}
exports.UmbHintTooltip = UmbHintTooltip;
exports.HintTooltip = new UmbHintTooltip();
